import { jsx as _jsx } from "react/jsx-runtime";
import cx from "classnames";
import React, { cloneElement } from "react";
import Button from "../../atoms/Button";
const HeaderButton = ({ children, className, onClick, ...props }, ref) => {
    return (_jsx(Button, { ref: ref, className: cx("h-8 w-8 !min-w-0 !px-0", className), onClick: onClick, variant: "neutral", size: "sm", ...props, children: children &&
            cloneElement(children, {
                className: cx(children.props.className, "w-4 h-4 fill-current text-black dark:text-white"),
            }) }));
};
export default React.forwardRef(HeaderButton);
//# sourceMappingURL=HeaderButton.js.map